import styled from 'styled-components';

import { getTheme } from 'lib/styles/getTheme';

export const Button = styled.button`
  font-family: ${getTheme('text.fontFamily')};
`;
